// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/hohofastIcon/iconfont.css
// module id = 1143
// module chunks = 0